// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Join from './components/Join';
import Login from './components/Login';
import Logout from './components/Logout';
import About from './components/About';
import Projects from './components/Projects';
import Proj1 from './components/Proj1';
import Chess from './components/Chess';
import Game from './components/Game';
import Home from './components/Home';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from './components/NotFound';
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/join" element={<Join />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/proj1" element={<Proj1 />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/admin" target="_blank"/>
        <Route path="/" element={<Home />} />
        <Route path="/chess" element={<ProtectedRoute element={Chess} />} />
        <Route path="/game/:matchid/:userid" element={<ProtectedRoute element={Game} />} />
         {/* <Route path="/game" element={<ProtectedRoute element={Board} />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
